import { render, staticRenderFns } from "./DoseRecommendationTab.vue?vue&type=template&id=feb8439e&scoped=true"
import script from "./DoseRecommendationTab.vue?vue&type=script&lang=js"
export * from "./DoseRecommendationTab.vue?vue&type=script&lang=js"
import style0 from "./DoseRecommendationTab.vue?vue&type=style&index=0&id=feb8439e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb8439e",
  null
  
)

export default component.exports